import { render, staticRenderFns } from "./ReenviarEmail.vue?vue&type=template&id=ca1cdb48&scoped=true"
import script from "./ReenviarEmail.vue?vue&type=script&lang=js"
export * from "./ReenviarEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca1cdb48",
  null
  
)

export default component.exports